import 'bootstrap/dist/css/bootstrap.css';
import logo from '../Immagine 2023-09-11 171343.jpg'
import {Link} from 'react-router-dom';
import './styles.css'
import glass from '../glass.png'
export default function Navbar(){

  const navStyle = {
    position: "relative",
    top: 0,
    width: "100%",
    backgroundColor: `#D9E724`, //background: `linear-gradient(to bottom, #D9E724, #212121)`
    borderBottomLeftRadius: "7px",
    borderBottomRightRadius: "7px",
  };
  

return (
<nav class="navbar navbar-expand" style={navStyle}>
<img
                          src={glass}
                          style={{ width: '25px', height: '25px', marginLeft: "10px"}} // Imposta la larghezza desiderata in pixel
                      />
      <a class="navbar-brand">
        <Link to="/" style={{textDecoration: 'none'}}><a class="nav-link" style={{cursor: 'pointer', fontWeight: "bold", color:"#8b008b"}}>FeatFinder</a></Link>
      </a>
      
      <div class="collapse navbar-collapse" id="navbarsExample06">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <Link to="/classic" style={{textDecoration: 'none'}}><a class="nav-link" style={{cursor: 'pointer'}}>Classic Mode<span class="sr-only"></span></a></Link>
          </li>
          <li class="nav-item disabled">
            <Link to="/discovery" style={{textDecoration: 'none'}} ><a class="nav-link" style={{cursor: 'pointer', textDecoration: "none"}}>Discovery Mode</a></Link>
          </li>
          <li class="nav-item">
            <Link to="/faq" style={{textDecoration: 'none'}}><a class="nav-link" style={{cursor: 'pointer'}}>FAQ</a></Link>
          </li>
        </ul>
      </div>
    </nav>

)






}